import { t } from 'i18next';
import * as yup from 'yup';
import { CustomFields } from '@utils/interfaces';
import {
  CUSTOM_INSURANCE_FIELD_MAX_LENGTH,
  getVisibleCustomInsuranceFields,
} from './CustomInsuranceFieldsForm.utils';

export const customInsuranceFieldsFormSchema = (
  customFields?: CustomFields,
) => {
  const requiredError = t('fieldsLabel.errors.isRequired');
  const maxLengthError = t('fieldsLabel.errors.customMaxLength');

  const fieldsShape = getVisibleCustomInsuranceFields(customFields).reduce(
    (shape, field) => {
      const baseSchema = yup
        .string()
        .max(CUSTOM_INSURANCE_FIELD_MAX_LENGTH, maxLengthError);

      shape[field.fieldKey] = field.required
        ? baseSchema.required(requiredError)
        : baseSchema.notRequired();

      return shape;
    },
    {} as Record<string, yup.AnySchema>,
  );

  return yup.object().shape({
    patientDetails: yup.object().shape({
      storeCustomFieldsInsurance: yup.object().shape(fieldsShape),
    }),
  });
};
